import storage from './storage';

/**
 * Identificador estável do navegador neste dispositivo (mesma chave usada pelo MFA). É um valor aleatório local, não é
 * fingerprint de hardware; o backend só o guarda como HMAC e ele apenas pontua o antifraude, nunca prova identidade.
 */
export function getDeviceId() {
  let id = storage.get('mfaDeviceId');
  if (!id) {
    id = globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    storage.set('mfaDeviceId', id);
  }
  return id;
}

export default getDeviceId;
